import styled from 'styled-components';
import { Container as BSContainer } from 'reactstrap';

export const Heading = styled.h5`
  text-align: center;
`

export const Amount = styled.div`
  padding: 10px 15px;
`

export const Content = styled.div`
  ${Heading}#paymentOrderId{
    text-decoration: underline;
    font-weight: 700;
    margin: 0;
  }
  ${Heading}.currency-tag{
    margin: 0;
    font-family: 'Nunito Bold';
  }
`

export const Text = styled.p`
  text-align: center;
  font-weight: ${props => props.bold ? 700 : 'normal'};
`

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem 0px;
  > img {
    width: 49px;
    height: 56px;
    object-fit: contain;
    margin-bottom: 0.5rem;
  }
  > img ~ span {
    font-weight: 700;
    font-size: 1.5rem;
  }
  @media (max-width: 768px) {
    > img {
      width: 80px;
      height: 80px;
    }
    > img ~ span {
      font-weight: 700;
      font-size: 1rem;
    }
  }
`

export const Box = styled.div`
  border: 1px solid #4a4a4a;
  min-height: 465px;
  width: 500px;
  padding: 1rem;
`

export const Container = styled(BSContainer)`
  margin-top: -80px;
  > div.row > div.col {
    /* margin-top: 15px; */
    margin-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: 768px) {
    ${'' /* margin-top: 0px; */}
    > div.row > div.col {
      margin-top: 0;
      padding: .5rem;
    }
    ${Box}{
      width: 100%;
    }
    ${Content} > ${Heading}#paymentOrderId{
      font-size: 1rem;
    }
  }
`;